/* eslint-disable react/jsx-key */

import { BLUEBOX_URL } from '@/constants/links'

import { HighlightText, HighlightTitle } from '@/components'

import CnpjImg from '/public/images/solution-cnpj.webp'
import CpfImg from '/public/images/solution-cpf.webp'
import NegativationImg from '/public/images/solution-negativation.webp'
import ManagementImg from '/public/images/solution-management.webp'
import InterconnectImg from '/public/images/solution-interconnect.webp'
import ProspectingImg from '/public/images/solution-prospecting.webp'
import RecoveryImg from '/public/images/solution-recovery.webp'
import AntifraudImg from '/public/images/solution-antifraud.webp'

export const POSTPAID_FILTERS = [
  {
    icon: 'equifax-building-search',
    text: 'Consulta de CNPJ'
  },
  {
    icon: 'equifax-user-search',
    text: 'Consulta de CPF'
  },
  {
    icon: 'equifax-user-check',
    text: 'Recuperação de clientes'
  },
  {
    icon: 'equifax-hand-check',
    text: 'Gestão de carteira'
  },
  {
    icon: 'equifax-box',
    text: 'Interconnect Box'
  }
]

export const HOME_FILTERS = [
  { icon: 'equifax-users-plus', text: 'Prospecção e Aquisição' },
  { icon: 'equifax-building-search', text: 'Consulta de CNPJ' },
  { icon: 'equifax-user-search', text: 'Consulta de CPF' },
  { icon: 'equifax-hand-check', text: 'Gestão de carteira' },
  { icon: 'equifax-user-check', text: 'Cobrança e Recuperação' },
  { icon: 'equifax-shield-3', text: 'Identificação e Antifraude' }
]

const ANTIFRAUD_DETAILS = [
  {
    icon: 'equifax-robot',

    text: 'Inteligência Artificial e comportamento de navegação para criar o modelo perfeito de análise de risco para o seu negócio.'
  },
  {
    icon: 'equifax-shopping-bag',
    text: 'Validação rápida de pedidos nas compras online.'
  },
  { icon: 'equifax-shield-2', text: 'Proteção máxima para o seu e-commerce.' }
]

const CPF_CONSULTATION_DETAILS = [
  {
    text: (
      <>
        <b>Acerta Essencial</b> - Relatório Básico
      </>
    )
  },
  {
    text: (
      <>
        <b>Acerta Mais</b> - Relatório Intermediário
      </>
    )
  },
  {
    text: (
      <>
        <b>Acerta Completo</b> - Relatório Completo
      </>
    )
  }
]

const CNPJ_CONSULTATION_DETAILS = [
  {
    text: (
      <>
        <b>Define Risco</b> - Relatório Básico
      </>
    )
  },
  {
    text: (
      <>
        <b>Define Negócio</b> - Relatório Intermediário
      </>
    )
  },
  {
    text: (
      <>
        <b>Define Limite</b> - Relatório Completo
      </>
    )
  }
]

const INTERCONNECT_DETAILS = [
  {
    title: 'Aumento de eficiência',
    text: 'Tome decisões de crédito mais rápidas, identificando clientes de alto risco'
  },
  {
    title: 'Redução de custos',
    text: 'Diminua despesas com análises manuais e relatórios extensos.'
  },
  {
    title: 'Tecnologia global em nuvem',
    text: 'Ideal para empresas que não possuem departamento de análise de crédito, plataforma ajustável ao tamanho do seu negócio.'
  },
  {
    title: 'Segurança',
    text: 'Segurança de dados em conformidade com as regulamentações.'
  },
  {
    title: 'Checagem simples',
    text: 'Verificação em tempo real, com sugestões claras e objetivas.'
  }
]

const MANAGEMENT_DETAILS = [
  {
    icon: 'equifax-user-analysis',
    text: 'Análise do comportamento financeiro dos seus clientes.'
  },
  {
    icon: 'equifax-graphic-analysis',
    text: 'Avaliação do risco de inadimplência.'
  }
]

const NEGATIVATION_DETAILS = [
  {
    icon: 'equifax-contract',
    title: 'Notificação',
    text: 'Avise seus clientes sobre dívidas por E-mail, SMS e Carta, incentivando a quitação antes do cadastro de inadimplência.'
  },
  {
    icon: 'equifax-contract-error',
    title: 'Negativação',
    text: 'Registro de dívidas no SCPC vinculadas a um CPF/CNPJ, com notificação ao devedor. Ideal para empresas que desejam formalizar cobranças e avaliar o risco de inadimplência de seus clientes.'
  }
]

const PROSPECTING_DETAILS = [
  {
    icon: 'equifax-megaphone',
    text: 'Segmentações personalizadas para campanhas de marketing.'
  },
  {
    icon: 'equifax-users-plus',
    text: 'Encontre os clientes ideais para o seu negócio.'
  },
  {
    icon: 'equifax-target',
    text: 'Oferte seus produtos e serviços para quem realmente pretende comprar.'
  },
  {
    icon: 'equifax-cube',
    text: (
      <>
        BlueBox:{' '}
        <a rel="noreferrer" id="solution-bluebox-link" href={BLUEBOX_URL}>
          <b>Saiba mais</b>
        </a>
        .
      </>
    )
  }
]

const RECOVERY_DETAILS = [
  {
    icon: 'sending-mail',
    text: 'Comunicações automatizadas, via e-mail e SMS.'
  },
  { icon: 'equifax-graphics', text: 'Maior recuperação de dívidas.' },
  { icon: 'equifax-money-check', text: 'Prejuízos cada vez menores.' }
]

export const POSTPAID_SERVICES = [
  {
    img: CnpjImg,
    title: 'Consulta de CNPJ',
    icon: 'equifax-building-search',
    actions_type: 'define',
    description:
      'As consultas de CNPJ utilizam dados restritivos, positivos e analíticos para apoiar suas decisões de crédito empresarial.',
    details: (
      <>
        {CNPJ_CONSULTATION_DETAILS.map(({ text }, i) => (
          <HighlightTitle
            text={text}
            icon="equifax-check"
            key={`solutions-detail-${i}`}
          />
        ))}
      </>
    )
  },
  {
    img: CpfImg,
    title: 'Consulta de CPF',
    icon: 'equifax-user-search',
    actions_type: 'acerta',
    description:
      'Visão integrada para decisão de crédito, com recomendação de aprovação e sugestão de limite mensal.',
    details: (
      <>
        {CPF_CONSULTATION_DETAILS.map(({ text }, i) => (
          <HighlightTitle
            text={text}
            icon="equifax-check"
            key={`solutions-detail-${i}`}
          />
        ))}
      </>
    )
  },
  {
    img: NegativationImg,
    title: 'Recuperação de clientes',
    icon: 'equifax-user-check',
    description:
      'Aumentamos significativamente suas chances de recuperação de dívidas com nossas soluções e serviços no plano Pós-pago.',
    details: (
      <>
        {NEGATIVATION_DETAILS.map(({ icon, title, text }, i) => (
          <HighlightText
            iconSize="small"
            icon={icon}
            title={title}
            text={text}
            key={`solutions-detail-${i}`}
          />
        ))}
      </>
    )
  },
  {
    img: ManagementImg,
    title: 'Gestão de carteira',
    icon: 'equifax-hand-check',
    description:
      'Cadastre seus clientes, defina os critérios que deseja acompanhar e receba notificações sempre que houver alguma mudança no comportamento financeiro.',
    details: (
      <>
        {MANAGEMENT_DETAILS.map(({ icon, text }, i) => (
          <HighlightTitle
            icon={icon}
            text={text}
            key={`solutions-detail-${i}`}
          />
        ))}
      </>
    )
  },
  {
    img: InterconnectImg,
    title: 'InterConnect Box',
    icon: 'equifax-box',
    description:
      'A solução ideal para pequenas e médias empresas que buscam análise rápida, segura e econômica para aprovação de crédito.',
    details: (
      <>
        {INTERCONNECT_DETAILS.map(({ title, text }, i) => (
          <HighlightText
            title={title}
            text={text}
            iconSize="small"
            icon="equifax-check"
            key={`solutions-detail-${i}`}
          />
        ))}
      </>
    )
  }
]

export const HOME_SERVICES = [
  {
    img: ProspectingImg,
    title: 'Prospecção e Aquisição',
    icon: 'equifax-users-plus',
    description:
      'Ajudamos sua empresa a descobrir novos clientes para ampliar suas oportunidades de negócio.',
    details: (
      <>
        {PROSPECTING_DETAILS.map(({ icon, text }, i) => (
          <HighlightTitle
            icon={icon}
            text={text}
            key={`solutions-detail-${i}`}
          />
        ))}
      </>
    )
  },
  {
    img: CnpjImg,
    title: 'Consulta de CNPJ',
    icon: 'equifax-building-search',
    actions_type: 'define',
    description:
      'As consultas de CNPJ utilizam dados restritivos, positivos e analíticos para apoiar suas decisões de crédito empresarial.',
    details: (
      <>
        {CNPJ_CONSULTATION_DETAILS.map(({ text }, i) => (
          <HighlightTitle
            text={text}
            icon="equifax-check"
            key={`solutions-detail-${i}`}
          />
        ))}
      </>
    )
  },
  {
    img: CpfImg,
    title: 'Consulta de CPF',
    icon: 'equifax-user-search',
    actions_type: 'acerta',
    description:
      'Visão integrada para decisão de crédito, com recomendação de aprovação e sugestão de limite mensal.',
    details: (
      <>
        {CPF_CONSULTATION_DETAILS.map(({ text }, i) => (
          <HighlightTitle
            text={text}
            icon="equifax-check"
            key={`solutions-detail-${i}`}
          />
        ))}
      </>
    )
  },
  {
    img: ManagementImg,
    title: 'Gestão de carteira',
    icon: 'equifax-hand-check',
    description:
      'Cadastre seus clientes, defina os critérios que deseja acompanhar e receba notificações sempre que houver alguma mudança no comportamento financeiro.',
    details: (
      <>
        {MANAGEMENT_DETAILS.map(({ icon, text }, i) => (
          <HighlightTitle
            icon={icon}
            text={text}
            key={`solutions-detail-${i}`}
          />
        ))}
      </>
    )
  },
  {
    img: RecoveryImg,
    title: 'Cobrança e Recuperação',
    icon: 'equifax-user-check',
    description:
      'Notifique e Negative devedores e aumente as chances de recuperação ao registrá-los no SCPC, alertando outras empresas sobre o risco de crédito.',
    details: (
      <>
        {RECOVERY_DETAILS.map(({ icon, text }, i) => (
          <HighlightTitle
            icon={icon}
            text={text}
            key={`solutions-detail-${i}`}
          />
        ))}
      </>
    )
  },
  {
    img: AntifraudImg,
    title: 'Identificação e Antifraude ',
    icon: 'equifax-shield-3',
    description:
      'Utilizamos dados para decisões assertivas e prevenção de fraudes em todas as etapas: onboarding, transações e chargebacks.',
    details: (
      <>
        {ANTIFRAUD_DETAILS.map(({ icon, text }, i) => (
          <HighlightTitle
            icon={icon}
            text={text}
            key={`solutions-detail-${i}`}
          />
        ))}
      </>
    )
  }
]
